





































import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./Info/Overview.vue";
import Container from "./Info/Container.vue";

import Monitor from "./Info/Monitor.vue";
import { uuid } from "../../utils/uuid";

const Type = {
  ABNORMAL: "异常",
  UNAVAILABLE: "不可用",
  NORMAL: "正常"
};

const Tabs: Header[] = [
  { label: "概览", name: "tab1", uuid: uuid() },
  { label: "容器组", name: "tab2", uuid: uuid() },
  { label: "资源监控", name: "tab3", uuid: uuid() }
];

export default Vue.extend({
  name: "HostInfo",
  components: { Overview, Container, Monitor },
  inheritAttrs: false,
  data() {
    return {
      Tabs,
      Type,
      dialog: false,
      tabActive: "tab1",
      hostData: null as any
    };
  },
  methods: {
    show(data: any) {
      this.dialog = true;
      this.hostData = data;
    },
    close() {
      this.dialog = false;
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    }
  }
});
